var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$wait.is("loading_sections")
    ? _c(
        "div",
        { staticClass: "loading" },
        [_c("Spinner", { attrs: { height: 40, width: 40 } })],
        1
      )
    : _c("div", [
        _c(
          "div",
          { staticClass: "grid grid--sectors" },
          _vm._l(_vm.sectors, function (item) {
            return _c(
              "div",
              { staticClass: "col-sm-4 col-6" },
              [_c("SectorCard", { attrs: { resource: item } })],
              1
            )
          }),
          0
        ),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }